import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
// import { selectDealerShip } from '../../../../../_redux/_actions';
import UiNavbarTopSelect from "../form/UiNavbarTopSelect";
import { campaignGetParticipantsByDealerRequest } from "../../../_redux/_actions";

const UiDealerSelect = (props) => {
    const [selectedDealer, setSelectedDealer] = useState(null);

    const actionDispatch = useDispatch();

    const { areaManagerDealers, auth } = useSelector((state) => {
        return {
            areaManagerDealers: state.campaign,
            auth: state.auth,
        };
    });

    const onChange = (item) => {
        props?.onChange(item);
        setSelectedDealer(item);
        if (props?.isDashBoard) {
            props.setDealerName(item?.label);
            actionDispatch(
                campaignGetParticipantsByDealerRequest({
                    dealerCode: item?.value,
                }),
            );
        }
    };

    useEffect(() => {
        if (
            selectedDealer === null &&
            areaManagerDealers?.areaManagerDealers[0]?.code &&
            props?.isDashBoard
        ) {
            props.setDealerName(
                areaManagerDealers?.areaManagerDealers[0]?.name,
            );
            actionDispatch(
                campaignGetParticipantsByDealerRequest({
                    dealerCode: areaManagerDealers?.areaManagerDealers[0]?.code,
                }),
            );
        }
    }, [areaManagerDealers.areaManagerDealers]);

    const defaultSelectedDealer = () => {
        if (
            props?.selectedDealer === null ||
            props?.selectedDealer === undefined
        ) {
            return {
                label: props?.dealerOptions[0].label,
                value: props?.dealerOptions[0].value,
            };
        } else if (
            props?.selectedDealer?.value === "" &&
            props?.selectedDealer?.label === ""
        ) {
            return null;
        } else {
            return {
                label: props?.selectedDealer.label,
                value: props?.selectedDealer.value,
            };
        }
    };

    return (
        <>
            {props?.dealerOptions.length > 0 && (
                <UiNavbarTopSelect
                    options={props?.dealerOptions}
                    onChange={onChange}
                    selectDealer={props.selectDealer}
                    selectQuarter={props.selectQuarter}
                    placeholder={"Type here"}
                    value={defaultSelectedDealer()}
                    defaultValue={{
                        label: props?.dealerOptions[0]?.label,
                        value: props?.dealerOptions[0]?.value,
                    }}
                />
            )}
        </>
    );
};

export default UiDealerSelect;
